/**
 * Created by Simon Zhao on 01/27/2022.
 * This service is used to control the visibility of the conditional gateway dialog component.
 * ------ maintenance history ------
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DiagramConditionalDialogOptions, DiagramConditionalDialogResult } from './diagram-conditional-gateway-dialog.model';

@Injectable()
export class DiagramConditionalGatewayDialogService {

    dialogClose$: Subject<DiagramConditionalDialogResult> = new Subject<DiagramConditionalDialogResult>();
    dialogOpen$: Subject<DiagramConditionalDialogOptions> = new Subject<DiagramConditionalDialogOptions>();

}
